// extracted by mini-css-extract-plugin
export default {"option":"NeyaTy","head":"OWxqM7","name":"aVyqdR","noaction":"k7Ic0S","description":"EvlcsT","readmore":"vvDxFN","more":"IOiEXf"};